/**
 * entry fill for production without Hot Module Reloading (HMR)
 */

import app from './app/';

app();
